import { jsx as _jsx } from "react/jsx-runtime";
import TreatsProductListing from './TreatsProductListing';
import TreatsProductPage from './TreatsProductPage';
var TreatsRoutes = [
    { index: true, element: _jsx(TreatsProductListing, {}) },
    { path: ':treatProductId', element: _jsx(TreatsProductPage, {}) },
];
export default TreatsRoutes;
